//importaciones de componentes
import { Box, Button,  FormControl, Grid, TextField, Typography } from '@mui/material'
import { ArrowLeftCircle } from 'react-feather'

const ModalInsuranceRenewal = ({useFetchInit, dataRequest} ) =>{

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,

        defaultData,
        
        //------------- Actions
        Actions
    } = useFetchInit



    // // ------------------------------------------------ actions
    const { handleClickReturnModal } = Actions

    
    // ------------------------------------------------ Formularios
    const { FormRequestModal:{formState, onInputChange} } = Forms

    
    return(
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 3 }}>
                <Grid item xs={12} sm={12} md={1} lg={1} >
                    <Box
                        sx={{
                        width: 50,
                        height: 50,
                        backgroundColor: formState.color,
                        marginRight: 2,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={10} lg={10}>
                    <Typography variant="h3" sx={{ color: 'black' }}>
                        {formState.tipo_evento}
                    </Typography>
                </Grid>
                
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 5, mb: 3}}>
                    <Typography sx={{mt:3,fontWeight: 'bold'}} variant='h6'>
                        Informacion General
                    </Typography>
                </Grid>

            </Grid>

            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="identificador">Identificador</label>
                        <TextField
                            id='identificador'
                            name='identificador'
                            size='small'
                            type='text'
                            placeholder='identificador'
                            onChange = {onInputChange}
                            hiddenLabel
                            value={ formState.identificador }
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5} sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="fecha_ren_seguro">Fecha de renovacion de seguro</label>
                        <TextField
                            id='fecha_ren_seguro'
                            name='fecha_ren_seguro'
                            size='small'
                            type='text'
                            placeholder='fecha_ren_seguro'
                            onChange = {onInputChange}
                            hiddenLabel
                            value={ formState.fecha_ren_seguro }
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="seguro">Costo de seguro (Q)</label>
                        <TextField
                            id='seguro'
                            name='seguro'
                            size='small'
                            type='text'
                            placeholder='seguro'
                            onChange = {onInputChange}
                            hiddenLabel
                            value={ formState.seguro }
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>


                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="cliente">Cliente</label>
                        <TextField
                            id='cliente'
                            name='cliente'
                            size='small'
                            type='text'
                            placeholder='cliente'
                            onChange = {onInputChange}
                            hiddenLabel
                            value={ formState.cliente }
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="telefono">Telefono</label>
                        <TextField
                            id='telefono'
                            name='telefono'
                            size='small'
                            type='text'
                            placeholder='telefono'
                            onChange = {onInputChange}
                            hiddenLabel
                            value={ formState.telefono }
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="dpi">DPI</label>
                        <TextField
                            id='dpi'
                            name='dpi'
                            size='small'
                            type='text'
                            placeholder='dpi'
                            onChange = {onInputChange}
                            hiddenLabel
                            value={ formState.dpi }
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={5} lg={5} sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="correo">Correo Electronico</label>
                        <TextField
                            id='correo'
                            name='correo'
                            size='small'
                            type='text'
                            placeholder='correo'
                            onChange = {onInputChange}
                            hiddenLabel
                            value={ formState.correo }
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={7} lg={7} sx={{ mb: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="direccion">Direccion</label>
                        <TextField
                            id='direccion'
                            name='direccion'
                            size='small'
                            type='text'
                            placeholder='direccion'
                            onChange = {onInputChange}
                            hiddenLabel
                            value={ formState.direccion }
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            
            <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }} sx={{mt:3}}>                
                <Grid item xs={12}>
                    <div className="text-center">
                        <Button 
                            startIcon={<ArrowLeftCircle/>}
                            variant="contained"
                            type="button" 
                            className='btn-round'
                            color='warning'
                            onClick={handleClickReturnModal} 
                            sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                        >
                            Volver
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}
export{
    ModalInsuranceRenewal
}